import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'


import {Backdrop, Block, Divider, Input, Overlay, Portal} from "reakit";
import {Box, Card, Flex, Heading, Image, Text} from 'rebass';
import InfiniteScroll from 'react-infinite-scroller';
import {Circle} from "styled-spinkit";

import {withFirebase} from "../../components/Firebase";
import {Span} from "../../components/Base";

import chevronRight from '../../resources/img/icons/Chevron_2@1x.png'
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import IosArrowBack from 'react-ionicons/lib/IosArrowBack'
import styled from "styled-components";


const HeaderWrapper = styled(Card)`
	position: relative;
	top: 0;
	left: 0;
	width: 100vw;
	max-height: 113px;
`;

const StyledHeader = styled(Heading)`
	margin-top: 2px;
`;

const FilterOverlay = styled(Overlay)`
	@media(max-width: 700px){
		width: 100% !important;
		height: 100% !important;
	}
`;

class Host extends Component {

	state = {
		searchTerm: '',
		hostList: [],
		selected: [],
		profileId: '',
		pageStart: 0,
		itemsPerPage: 20
	};

	componentDidMount() {
		const {defaultValue} = this.props;
		const profileId = localStorage.getItem('uid');
		if (defaultValue) {
			if(defaultValue.length > 0)
				this.setState({selected: [defaultValue[0]]})
			else
				this.setState({selected: [-1]})
		}
		this.listener = this.getParentListner();
		this.setState({profileId})
	}

	getParentListner = () => {
		return this.props.firebase.parents().onSnapshot(snapshot => {
			/**
			 * Place Parents of student in the Top of Host List.
			 */
			const { student } = this.props;
			const parents = student.parents || [];
			let result = [];
			snapshot.docs.forEach(doc => {
				const data = doc.data();
				// Show only activated Host
				if(data.activated !== false) {
					if(parents.includes(doc.id))
						result.unshift({id: doc.id, ...doc.data()});
					else	
						result.push({id: doc.id, ...doc.data()})
				}
				
			});
			this.setState({hostList: result})
		})
	};

	handleSelect = (name) => {
		const {handleUpdate} = this.props;

		this.setState({selected: [name]});
		handleUpdate('host', [name])

	};

	filterHosts = () => {
		const {hostList, searchTerm} = this.state
		if (searchTerm !== '') {
			return hostList.filter(student => (student.first_name.toLowerCase() + ' ' + student.last_name.toLowerCase()).includes(searchTerm.toLowerCase()))
		} else {
			return hostList
		}
	};

	componentWillUnmount() {
		this.listener()
	}

	loadMore = (page) => {
		this.setState({pageStart: page })
	}

	renderHostList = (items, overlay) => {
		const { student } = this.props;
		const {selected} = this.state;
		return (
			<>
			{items.map(host => (
					<Box key={host.id} width={1} onClick={() => {
						this.setState({selected: host});
						this.handleSelect(host.id);
						overlay.hide()
					}}>
						<Flex>
							<Box>
								{student !== null && student.parents.includes(host.id) ?
									<Fragment>

										<Text pl='7px' fontWeight={600}  py={3}>{host.first_name} {host.last_name}<Span
											color={'meta'}> (Parent)</Span></Text>
									</Fragment>
									:
									<Text pl='7px' fontWeight={600} py={3}>{host.first_name} {host.last_name}</Text>
								}

							</Box>
							<Box ml={'auto'}/>
							<Box pt={3} pr={2}>
								{selected.includes(host.id) && <Image src={check}/>}
							</Box>

						</Flex>
						<Box width={1}><Divider margin={0} padding={0}/></Box>
					</Box>
			))}
			</>
		)
	}

	render() {
		const {selected, pageStart, itemsPerPage} = this.state;
		const {student, height, width, newLeave} = this.props;
 
		const hostList = this.filterHosts();
		// types.forEach(type => typeList.push({ty}))

		const items = hostList.slice(0, itemsPerPage + pageStart*itemsPerPage)

		const hasMore = items.length < hostList.length;

		return (
			<Overlay.Container>
				{overlay => (
					
					<Block width={'100%'}>
						<Flex flexWrap={'wrap'} width={1} onClick={overlay.show} {...overlay} px={newLeave ? 3 : 0}>
							<Box pl={'7px'}>
								<Text py={3} fontSize={'16px'} fontWeight={600}>Host</Text>
							</Box>
							<Box mr={'auto'}/><Box>
							{
								hostList.filter(host => selected.includes(host.id)).map(host => (
								<Fragment key={host.id}>
									{student !== null && student.parents.includes(host.id) ?
										<Fragment>

											<Text color={'meta'} fontWeight={600} py={3}>{host.first_name} {host.last_name} <Span
												color={'meta'}>(Parent)</Span></Text>
										</Fragment>
										:
										<Text fontWeight={600} py={3} color={'meta'}>{host.first_name} {host.last_name}</Text>
									}
								</Fragment>
							))}
							{
								selected.includes(-1) &&
								<Text fontWeight={600} py={3} color={'meta'}>No Host Necessary</Text>
							}
						</Box>
							<Box pl={3}>
								<Text py={3} color='metaText'><Image src={chevronRight}/> </Text>
							</Box>
						</Flex>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
								
							<FilterOverlay use={Portal} {...overlay} margin={0} padding={0} overflow={'auto'} height={height || '65%'} width={width || "65%"}>
							<InfiniteScroll
									pageStart={pageStart}
									loadMore={this.loadMore}
									hasMore={hasMore}
									useWindow={false}
									loader={<Flex justifyContent={'center'} flexWrap={'wrap'} width={1} key={0}><Circle/></Flex>}
							>
								<HeaderWrapper boxShadow={'main'} width={'100% !important'} p={2}>
									<Box ml={0} mt={2} height={'30px'} width={'30px'}>
										<IosArrowBack fontSize={'30px'} onClick={overlay.hide}/>
									</Box>
									<StyledHeader pl={1} pt={2} pb={0} mb={0}>Hosts</StyledHeader>
								</HeaderWrapper>
								<Block>
							
									<Block height={'100%'}>
										<Flex justifyContent={'center'}>
										<Card width={0.9} boxShadow={'main'} mt={3}>
											<Input fontWeight={600} placeholder={'Search hosts....'}
												onChange={(e) => this.setState({searchTerm: e.target.value})}/>
										</Card>
										</Flex>
										<Flex flexDirection={'column'} p={1} mt={1}>
											<Box width={1} onClick={() => {
												this.handleSelect(-1);
												overlay.hide()
											}}>
												<Flex>
													<Box>
														<Text pl='7px' fontWeight={600} py={3}>No Host Necessary</Text>
													</Box>
													<Box ml={'auto'}/>
													<Box pt={3} pr={2}>
														{selected.includes(-1) && <Image src={check}/>}
													</Box>

												</Flex>
												<Box width={1}><Divider margin={0} padding={0}/></Box>
											</Box>
											{
												this.renderHostList(items, overlay)
											}
										</Flex>
									</Block>
								</Block>
							</InfiniteScroll>
							</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}


Host.propTypes = {
	defaultValue: PropTypes.string
};

Host.defaultProps = {
	defaultValue: null
};

export default withFirebase(Host)
